import React from 'react';
import {
  FDStack,
  FDTitleText,
  FDBox,
} from '@facet-wealth/design';
import MetaControl from 'Components/UI/Meta/MetaControl';
import PropTypes from 'prop-types';
import fr from 'facet-rest';

export const ProductHeader = ({
  productResource,
  metaOverrideSet,
}) => {
  const documentName = productResource.selectedOptionPrompt('document');

  return (
    <FDStack direction={'row'} spacing={2} justifyContent={'space-between'}>
      <FDBox>
        <MetaControl resource={productResource} attrName={'title'} metaOverrideSet={metaOverrideSet} />
        <FDTitleText value={documentName} />
      </FDBox>
      <FDStack justifyContent={'flex-end'} direction={'column'}>
        <MetaControl resource={productResource} attrName={'firstYearAmount'} metaOverrideSet={metaOverrideSet} />
        <MetaControl resource={productResource} attrName={'recurringAmount'} metaOverrideSet={metaOverrideSet} />
        <MetaControl resource={productResource} attrName={'recurringAmountNote'} metaOverrideSet={metaOverrideSet} />
      </FDStack>
    </FDStack>
  );
};

ProductHeader.defaultProps = {};

ProductHeader.propTypes = {
  productResource: PropTypes.instanceOf(fr.Resource).isRequired,
  metaOverrideSet: PropTypes.object.isRequired,
};
